// extracted by mini-css-extract-plugin
export default {"active":"styles_active__x14ab","mainLink":"styles_mainLink__SDoXY"};